<script>
    import { getTranslations } from "$lib/utilities/getTranslations";
    import { store } from "$lib/utilities/store";

    export let col;
    export let settingId;
    export let key;
    export let lang;

    let loading = false;

    const handleTranslate = async () => {
        loading = true;
        await getTranslations($store, col, settingId, key, lang);
        loading = false;
    };
</script>

<div>
    <div class="my-2">
        <button
            class={`btn btn-sm btn-primary ${loading ? "loading" : ""}`}
            disabled={loading}
            on:click|preventDefault={handleTranslate}
        >
            Update Translations
        </button>
    </div>
</div>
